import { RecipientType } from "../../../../types/message";
import "./recipientsSearchModal.css";

interface Props {
  searchRecipients: RecipientType[];
  addRecipient: (recipient: RecipientType) => void;
}

function RecipientsSearchModal({ searchRecipients, addRecipient }: Props) {
  return (
    <div className="position-absolute recipientSearchModal">
      <div className="recipients">
        {searchRecipients.map((item) => (
          <div
            className="p-2 recipient d-flex gap-2 align-items-center recipient"
            key={item.id}
            onClick={() => addRecipient(item)}
          >
            <div>
              {item?.profilePic ? (
                <div className="profileImgWrapper me-2">
                  <img
                    src={item?.profilePic}
                    alt="Profile Image"
                    className="profileImg img-fluid"
                  />
                </div>
              ) : (
                <div className="recipientImg d-flex justify-content-center align-items-center">
                  {item.username[0]}
                </div>
              )}
            </div>
            <div>
              <div className="recipientName">{item.username}</div>
              <div className="recipientEmail">{item.email}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RecipientsSearchModal;
